export default "__VITE_ASSET__CR_bvMMl__"